// /web/src/pages/Privacy.jsx
const lastUpdated = new Date().toISOString().slice(0, 10);

export default function Privacy() {
  return (
    <section className="pd-blog prose">
      <header className="pd-blog__header">
        <p className="small" style={{ textTransform: "uppercase", letterSpacing: 0.4 }}>
          Last updated {lastUpdated}
        </p>
        <h1>Privacy Policy</h1>
        <p className="lead" style={{ marginTop: 0 }}>
          How Pebbledash collects, stores, and protects the personal data required to run the
          service.
        </p>
      </header>

      <article className="pd-blog__body">
        <p>
          Pebbledash (“we”, “us”, “our”) provides design automation tools for architects and
          developers. We are the data controller for personal data we process in connection with this
          website and service.
        </p>

        <h2>What we collect</h2>
        <ul>
          <li>
            <strong>Account data</strong>: name, email, Auth0 identifier.
          </li>
          <li>
            <strong>Usage data</strong>: calculator runs, token balance, plan tier.
          </li>
          <li>
            <strong>Project data</strong>: project names and inputs you add (e.g., floor areas,
            assumptions).
          </li>
          <li>
            <strong>Billing</strong>: handled by Stripe; we do not store full card details.
          </li>
          <li>
            <strong>Support</strong>: messages you send via the contact form or email.
          </li>
          <li>
            <strong>Cookies</strong>: essential cookies for login; optional analytics cookies only
            with your consent.
          </li>
        </ul>

        <h2>Why we collect it (lawful bases)</h2>
        <ul>
          <li>
            <strong>Provide the service</strong> (contract): authentication, run calculators, manage
            tokens.
          </li>
          <li>
            <strong>Billing</strong> (contract/legal obligation): process subscriptions and receipts.
          </li>
          <li>
            <strong>Analytics</strong> (consent): understand aggregated product usage to improve the
            app.
          </li>
          <li>
            <strong>Support &amp; security</strong> (legitimate interests): keep the service reliable
            and secure.
          </li>
        </ul>

        <h2>Processors we use</h2>
        <ul>
          <li>
            <strong>Auth0</strong> (authentication)
          </li>
          <li>
            <strong>Stripe</strong> (payments)
          </li>
          <li>
            <strong>Amplitude</strong> (product analytics, optional)
          </li>
          <li>
            <strong>Sentry</strong> (error monitoring)
          </li>
          <li>
            <strong>Resend / Postmark</strong> (transactional email)
          </li>
          <li>
            <strong>Hosting</strong>: Vercel (frontend), Render/Railway/Fly (backend), Neon/Supabase
            (database)
          </li>
        </ul>

        <h2>Cookies &amp; analytics</h2>
        <p>
          Essential cookies are required to operate and secure the site. Analytics cookies are
          <strong>off by default</strong> and only set if you consent. You can change your choice
          anytime via “Cookie settings” in the footer.
        </p>

        <h2>Retention</h2>
        <p>
          We retain account and project data while your account is active. You can request deletion
          at any time; we’ll also remove data after a reasonable inactivity period, subject to legal
          obligations.
        </p>

        <h2>Your rights</h2>
        <p>
          Under GDPR/UK GDPR you may request access, correction, deletion, restriction, portability,
          and object to certain processing. To exercise these rights, email{" "}
          <a href="mailto:info@pebbledash.co">info@pebbledash.co</a>.
        </p>

        <h2>International transfers</h2>
        <p>
          Some processors may store data outside your country. We use appropriate safeguards such as
          the EU Standard Contractual Clauses where applicable.
        </p>

        <h2>Contact</h2>
        <p>
          Email: <a href="mailto:info@pebbledash.co">info@pebbledash.co</a>
        </p>

        <h2>Changes</h2>
        <p>We’ll post any privacy changes here and update the “Last updated” date.</p>
      </article>
    </section>
  );
}
